<template>
    <b-modal
        id="dailyManifestModal"
        title="Daily Manifest"
        @ok="handleOk"
        @cancel="reset"
        @hidden="reset"
    >
        <form ref="form" @submit.stop.prevent="handleOk">
            <b-form-group>
                <b-row>
                    <b-col>
                        <p>{{ $t('core.dailyManifest.SelectDate') }}</p>
                        <Datepicker
                            v-model="shipDate"
                            input-class="form-control form-control-sm"
                            name="dailyManifestDatepicker"
                            :typeable="false"
                        />
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col>
                        <b-form-group
                            :label="$t('core.dailyManifest.ChooseAccounts')"
                        >
                            <b-form-checkbox-group
                                stacked
                                v-model="selectedAccountIds"
                                name="manifestAccountGroup"
                            >
                                <b-form-checkbox
                                    v-for="account in companyAccounts"
                                    :key="account.value"
                                    :value="account.id"
                                >
                                    <span
                                        class="align-middle"
                                    >{{ account.displayName }}</span>
                                </b-form-checkbox>
                            </b-form-checkbox-group>

                            <div class="mt-3" v-if="companyAccounts.length > 1">
                                <a
                                    href="#"
                                    @click="selectAll"
                                    name="manifestSelectAll"
                                >
                                    {{
                                    $t('core.dailyManifest.SelectAll')
                                    }}
                                </a>
                                <a
                                    href="#"
                                    class="ml-2"
                                    @click="deselectAll"
                                    name="manifestDeselectAll"
                                >{{ $t('core.dailyManifest.DeselectAll') }}</a>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-invalid-feedback
                name="manifestInvalidFeedback"
                v-if="invalidFeedback"
                :state="state"
            >{{ invalidFeedback }}</b-form-invalid-feedback>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">Cancel</b-button>
            <b-button @click="ok()" variant="primary" name="manifestDownload">
                {{ $t('core.dailyManifest.DownloadManifest') }}
                <b-spinner v-if="spinnerLoading" small></b-spinner>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  import vSelect from './vSelect';
  import Datepicker from 'vuejs-datepicker';
  import { ACTIONS, MUTATIONS, CORE_PREFIX } from '../store/constants';

  export default {
      components: {
          vSelect,
          Datepicker,
      },
      data() {
          return {
              shipDate: new Date(),
              invalidFeedback: '',
              state: null,
              spinnerLoading: false,
              accounts: [],
              selectedAccountIds: [],
          };
      },

      props: {
          companyAccounts: { required: true, type: Array },
      },

      methods: {
          handleOk(bvModalEvt) {
              bvModalEvt.preventDefault();
              this.getManifest();
          },
          selectAll() {
              this.companyAccounts.forEach((x) => {
                  this.selectedAccountIds.push(x.id);
              });
          },
          deselectAll() {
              this.selectedAccountIds = [];
          },
          async getManifest() {
              if (this.selectedAccountIds.length === 0) {
                  this.state = false;
                  this.invalidFeedback = 'Please select atleast one account';
                  return;
              }

              this.spinnerLoading = true;

              const response = await this.$store.dispatch(
                  CORE_PREFIX + ACTIONS.CORE.FETCH_DAILY_MANIFEST,
                  { accountIds: this.selectedAccountIds, shipDate: this.shipDate }
              );

              if (response.error) {
                  this.invalidFeedback = response.error;
                  this.state = false;
              } else {
                  this.$bvModal.hide('dailyManifestModal');
                  window.open(response.url, '_blank');
              }

              this.spinnerLoading = false;
          },

          showDailyManifestModal() {
              this.companyAccounts.forEach((element) => {
                  this.selectedAccountIds.push(element.id);
              });

              this.$bvModal.show('dailyManifestModal');
          },

          reset() {
              this.shipDate = new Date();
              this.state = null;
              this.invalidFeedback = '';
              this.spinnerLoading = false;
              this.selectedAccountIds = [];
          },
      },
  };
</script>
